<template lang="html">
  <section id="newsletter" class="modulo-newsletter">
    <div class="animation">
      <h2>
        <span
          >{{ $t("newsletter.banner.title1") }}
          <strong>{{ $t("newsletter.banner.title1_1") }}</strong>
          {{ $t("newsletter.banner.title1_2") }}</span
        >
        <span class="-small">{{ $t("newsletter.banner.title2") }}</span>
        <span class="-medium">{{ $t("newsletter.banner.title3") }}</span>
        <span class="-big">{{ $t("newsletter.banner.title4") }}</span>
      </h2>
      <img src="/static/img/newsletter/pc.png" alt="pc" class="decor1" />
      <img
        src="/static/img/newsletter/gusanito.png"
        alt="gusanito"
        class="decor2"
      />
    </div>
    <div class="container">
      <form
        id="formNewsletter"
        class="formulario row-between waypoints"
        @submit.prevent="validateBeforeSubmit"
      >
        <div class="contenedor-input middle ">
          <input
            type="text"
            class="input-text"
            v-validate="'required'"
            name="nombre"
            :placeholder="$t('formulario.nombre') + '*'"
            v-model="form.name"
          />
          <span
            :class="['error', { 'animated shake': clicked }]"
            v-if="clicked"
            >{{ errors.first("nombre") }}</span
          >
        </div>
        <div class="contenedor-input middle ">
          <input
            type="text"
            class="input-text"
            name="apellidos"
            v-validate="'required'"
            :placeholder="$t('formulario.apellidos') + '*'"
            v-model="form.surnames"
          />
          <span
            :class="['error', { 'animated shake': clicked }]"
            v-if="clicked"
            >{{ errors.first("apellidos") }}</span
          >
        </div>

        <div class="contenedor-input middle ">
          <input
            type="text"
            class="input-text"
            v-validate="'required|email'"
            name="email"
            :placeholder="$t('formulario.email') + '*'"
            v-model="form.email"
          />
          <span
            :class="['error', { 'animated shake': clicked }]"
            v-if="clicked"
            >{{ errors.first("email") }}</span
          >
        </div>
        <div class="contenedor-input middle -date" :hide="hideLabel">
          <label for="fecha_nacimiento"
            >{{ $t("formulario.fecha_nacimiento") }}*</label
          >
          <input
            type="date"
            class="input-text"
            v-validate="'required'"
            name="fecha_nacimiento"
            :placeholder="$t('formulario.fecha_nacimiento') + '*'"
            v-model="form.birthday"
          />
          <span
            :class="['error', { 'animated shake': clicked }]"
            v-if="form.birthday == null && clicked"
            >{{$t('newsletter.banner.obligatorioFechaNacimiento') }}</span
          >
        </div>

        <div class="contenedor-input middle ">
          <select
            name="tipo"
            id="tipo"
            v-validate="'required'"
            v-model="form.type"
          >
            <option value="null" disabled>{{
              $t("newsletter.banner.tipoContactoLabel")
            }}</option>
            <option
              v-for="(tipo, key) in $t('newsletter.banner.tipoContactoOptions')"
              :value="tipo"
              >{{ tipo }}</option
            >
          </select>
          <span
            :class="['error', { 'animated shake': clicked }]"
            v-if="clicked"
            >{{ errors.first("tipo") }}</span
          >
        </div>
        <div class="contenedor-input middle ">
          <input
            type="text"
            class="input-text"
            v-validate="'required'"
            name="cp"
            v-model="form.cp"
            :placeholder="$t('formulario.cp') + '*'"
          />
          <span
            :class="['error', { 'animated shake': clicked }]"
            v-if="clicked"
            >{{ errors.first("cp") }}</span
          >
        </div>

        <div class="contenedor-checks">
          <div class="contenedor-input">
            <input
              type="checkbox"
              id="politica"
              v-validate="'required'"
              name="politica"
              v-model="form.privacy"
            />
            <label for="politica"
              >{{ $t("formulario.he_leido") }}
              <router-link
                :to="
                  '/' + $i18n.locale + '/' + $t('enlaces.politica_privacidad')
                "
                >{{ $t("formulario.y_acepto") }}*</router-link
              ></label
            >
            <span
              :class="['error', { 'animated shake': clicked }]"
              v-if="clicked"
              >{{ errors.first("politica") }}</span
            >
          </div>

          <div class="contenedor-input" hidden>
            <input
              type="checkbox"
              id="publicidad"
              name="publicidad"
              v-model="form.newsletter"
            />
            <label for="publicidad">{{ $t("formulario.publicidad") }}</label>
          </div>
        </div>

        <div class="contenedor-boton row-start ">
          <button class="btn -action" :sending="sending">
            {{ $t("newsletter.popup.cta") }}
          </button>
        </div>
        <img
          src="/static/img/newsletter/palomita-avion.png"
          alt="palomita y avión"
          class="decor3"
        />
      </form>
    </div>
    <section class="msg-form-popup" v-if="send">
      <div class="msg-container" :data-error="errorForm">
        <button class="close" @click="send = false">
          <img src="/static/img/icon-close-red.svg" alt="cerrar" />
        </button>
        <p v-if="errorForm == false" v-html="$t('newsletter.banner.msg_succes')"></p>
        <p v-else v-html="$t('newsletter.banner.msg_error')"></p>
      </div>
    </section>
  </section>
</template>

<script lang="js">
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import axios from 'axios';
Vue.use(VeeValidate);
import { mapGetters, mapActions } from 'vuex'
export default  {
	name: 'modulo-newsletter',
	data(){
		return{
			clicked: false,
			send: false,
			sending: false,
			errorForm:false,
      hideLabel : false,
			form:{
        name: "",
        surnames: "",
        email: "",
        birthday:null,
        cp: "",
        type: null,
        privacy: false,
        newsletter: true
			}
		}
	},
	 methods: {
	  ...mapActions(['sendDistribuidores']),
	  validateBeforeSubmit: function () {
	  	this.clicked = true;
	  	this.$validator.validateAll().then(canSend => {
	  		if (canSend) {
	  			this.sending = true;
          try {
            axios.post('https://back.risi.es/api/newsletter', this.form, {
              headers: {
                'Content-Type': 'application/json'
              }
            }).then(response => {
              if (response.status) {
                this.send = true,
                this.form = {
                  name: "",
                  surnames: "",
                  email: "",
                  birthday:'',
                  cp: "",
                  type: null,
                  privacy: false,
                  newsletter: true
                }
                this.hideLabel = false;
                this.$validator.reset()
              } 
            }).catch(function (error) {
                this.errorForm = true
                this.send = true,
                this.form = {
                  name: "",
                  surnames: "",
                  email: "",
                  birthday:'',
                  cp: "",
                  type: null,
                  privacy: false,
                  newsletter: true
                }
                this.hideLabel = false;
                this.$validator.reset()
               
             });
               
          } catch (error) {
            console.error('Error al enviar el lead:', error);
          }
	  		}
			});
		}
  },
    watch: {
      'form.birthday': function () {
        if (this.form.birthday != null) {
            this.hideLabel = true;
        }
      }
    }
}
</script>
<style>
.contenedor-input.-date {
  position: relative;
}
.contenedor-input.-date label {
  position: absolute;
  top: 18px;
  left: 13px;
  color: white;
  z-index: 8;
  pointer-events: none;
}
.contenedor-input.-date[hide="true"] label {
  display: none;
}
input[type="date"] {
  position: relative;
  cursor: pointer;
  color: transparent;
}
.contenedor-input.-date[hide="true"] input {
  color: white;
}
input[type="date"]:after {
  color: white;
  padding: 0px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
}
input[type="date"]::-webkit-calendar-picker-indicator {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: auto;
  height: auto;
  color: white;
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/views/home/modulo-newsletter.vue